import { CONSTANTS } from '../../_data/constants.js';
export function isEntityItem(item) {
    return item.itemKind === CONSTANTS.Enums.ItemKind.entity;
}
export function isAboveAndOnShape(shape) {
    return shape?.labelHostCapability === 'above-and-on';
}
export function isAboveAndOnEntityItem(shape) {
    return isAboveAndOnShape(shape);
}
export function isConnectorItem(item) {
    return item.itemKind === CONSTANTS.Enums.ItemKind.connector;
}
